import React from 'react';
import { useTranslation } from 'react-i18next';

function Services() {
  const { t } = useTranslation();

  const services = [
    {
      id: 'web',
      title: t('services.web.title'),
      items: t('services.web.items', { returnObjects: true })
    },
    {
      id: 'gis',
      title: t('services.gis.title'),
      items: t('services.gis.items', { returnObjects: true })
    },
    {
      id: 'photogrammetry',
      title: t('services.photogrammetry.title'),
      items: t('services.photogrammetry.items', { returnObjects: true })
    },
    {
      id: 'consulting',
      title: t('services.consulting.title'),
      items: t('services.consulting.items', { returnObjects: true })
    }
  ];

  const whatsappQuoteUrl = `https://wa.me/221785949274?text=${encodeURIComponent(t('whatsapp.quoteMessage'))}`;

  return (
    <section className="services-section" id="services">
      <h3>{t('services.title')}</h3>
      <p className="services-intro">{t('services.intro')}</p>
      <div className="services-grid">
        {services.map((service) => (
          <div key={service.id} className="service-card">
            <h4>{service.title}</h4>
            <ul>
              {service.items.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="services-cta">
        <a
          className="cta-button whatsapp"
          href={whatsappQuoteUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('services.cta')}
        </a>
      </div>
    </section>
  );
}

export default Services;

